import { dateRangeChipRenderingOptions } from '@iris/modules/module-filters-v2/chips/rendering-options';
import { appendDateRangeQueryParamsFn } from '@iris/modules/module-filters-v2/query-params';
import { filterValueObjectIsEmpty } from '@iris/modules/module-filters-v2/utils';
import { IrisFilterPropertyMeta } from './filter-property-meta';
import { DatetimeUnit } from '@iris/common/modules/date';
import { Injector } from '@angular/core';
import { IrisUserTimePipe } from '@iris/common/modules/time';

export function dateRangeFilterMeta(
  propertyId: string,
  label: string,
  injector: Injector,
  timeZone: string,
  accuracy: DatetimeUnit = 'day',
  fieldName: string = propertyId,
): IrisFilterPropertyMeta {
  const userTimePipe = injector.get(IrisUserTimePipe);
  return {
    propertyId,
    label,
    appendFilterQueryParamsFn: appendDateRangeQueryParamsFn(fieldName, timeZone, accuracy),
    chipRenderingOptions: dateRangeChipRenderingOptions(date => userTimePipe.transform(date, 'date', timeZone)),
    filterValueIsEmpty: filterValueObjectIsEmpty,
  };
}
